import { LocalStorageKeys } from "../types/LocalStorageKeys";

export function clearAutoDetectedCurrency(): void {
  localStorage.removeItem(LocalStorageKeys.AUTO_DETECTED_CURRENCY);
}
